import React, { useRef, useEffect } from "react";

import { ShimmerComp } from "./Shimmer.style";
import { ShimmerType } from "./ShimmerType";

export default function Shimmer({
  width,
  height,
  margin,
  padding,
  children,
}: ShimmerType) {
  return (
    <ShimmerComp
      padding={padding}
      width={width}
      height={height}
      margin={margin}
    >
      {" "}
      {children}
    </ShimmerComp>
  );
}
